import { useEffect, useState } from "react";
import { DeleteUser, GetAllUsers, GetAllUsersWithRole, UpdateUserInfo } from "../services/ApiServices/UserService";
import { Card, CardHeader, Typography, CardBody, IconButton, Tooltip, Button } from "@material-tailwind/react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";

type User = {
    id: string;
    userName: string;
    email: string;
    phoneNumber: string;
    dateOfBirth: string;
    address: string;
}

type AdminUserProps = {
    loading: boolean;
    setLoading: (loading: boolean) => void;
    id: string;
}

function AdminUser({ id, loading, setLoading }: AdminUserProps) {
    const [users, setUsers] = useState<User[]>([]);

    const TABLE_HEAD = ["ID", "Tên đăng nhập", "Email", "SĐT", "Ngày sinh", "Địa chỉ", ""];

    const fetchUsers = () => {
        setLoading(true);
        GetAllUsersWithRole()
            .then((data) => {
                setUsers(data.filter((user:any) => user.roles[0].name != "Admin"));
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleDeleteUser = async (userId: string) => {
        if (id != userId) { 
            setLoading(true);
            try {
                await DeleteUser(userId);
                fetchUsers(); 
            } catch (error) {
                console.error("Error deleting user:", error);
                setLoading(false);
            }
        } else {
            console.error("Only administrators can delete users.");
        }
    };

    return (
        <Card placeholder={""} className="h-full w-full">
            <CardHeader placeholder={""} floated={false} shadow={false} className="rounded-none">
                <div className="mb-8 flex items-center gap-8 justify-between mt-3">
                    <div>
                        <Typography placeholder={""} variant="h2" color="blue-gray">
                            Danh sách người dùng
                        </Typography>
                        <Typography placeholder={""} color="gray" className="mt-1 font-normal">
                            Xem tất cả thông tin của người dùng
                        </Typography>
                    </div>
                    {/* Add Button to add new user if needed */}
                </div>
            </CardHeader>
            <CardBody placeholder={""} className="overflow-scroll px-0">
    <table className="mt-4 w-full min-w-max table-auto text-left">
        <thead>
            <tr>
                {TABLE_HEAD.map((head) => (
                    <th key={head} className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                        <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                            {head}
                        </Typography>
                    </th>
                ))}
                <th className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4"></th> {/* Empty cell for actions */}
            </tr>
        </thead>
        <tbody>
            {users.map((user) => (
                <tr key={user.id}>
                    <td className="p-4 border-b border-blue-gray-50">
                        <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                {user.id}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                        <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                            {user.userName}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                        <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                            {user.email}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                        <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                            {user.phoneNumber}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                        <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                            {user.dateOfBirth}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                        <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                            {user.address}
                        </Typography>
                    </td>
                    <td className="p-4 border-b border-blue-gray-50">
                        <div className="flex items-center gap-2">
                            <Tooltip content="Delete User">
                                <IconButton onClick={() => handleDeleteUser(user.id)} placeholder={""} variant="text">
                                    <TrashIcon className="h-4 w-4 text-red-500" />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </td>
                </tr>
            ))}
        </tbody>
    </table>
</CardBody>

        </Card>
    );
}
export default AdminUser;
